
<template>
  <div class="search__container">
    <h1>{{translations.search.button}} </h1>

    <v-form v-on:submit.prevent autocomplete="off">
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              outlined

              :label="translations.search.prefill"
              type="text"
              class="search-input"
            >
              <template v-slot:prepend>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" >
                      mdi-magnify
                    </v-icon>
                  </template>
                </v-tooltip>
              </template>
              <template v-slot:append>
                 <v-icon
                   v-if="search"
                   tabindex="0"
                   role="button"
                   aria-label="Clear Search"
                   @click="search = ''"
                   @keydown.enter="search = ''"
                   class="custom-clear-icon"
                 >
                   mdi-close
                 </v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <div class="list-block">
      <div role="status">
        <h4 v-if="search !== null && search !== ''" class="results-text">{{translations.search.part1}} {{searchApp.length}} {{translations.search.part2}}</h4>
        <h4 v-if="searchApp.length === 0" class="results-text">{{translations.search.noresults}}</h4>
      </div>

      <v-data-iterator
        v-if="search !== null && search !== '' && searchApp.length !== 0"
        :items="searchApp"
        item-key="id"
        :items-per-page.sync="itemsPerPage"
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 30, 40, 50]
        }"
      >
        <template v-slot:default="{ items}">
          <v-list two-line subheader>
            <v-list-item
              v-for="item in items"
              :key="item.id"
              class="app-search__list-item"
            >
              <RouterLink :to="openPage(item)" class="app-search__list-item-link">
                <v-list-item-avatar>
                  <v-icon v-if="item.type === 'organisation'" color="primary">mdi-domain</v-icon>
                  <v-icon v-else color="primary">mdi-book-open-page-variant</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-if="item.type==='cms_page'" v-text="item.page_title "></v-list-item-title>
                  <v-list-item-title v-else-if="item.type==='category'" v-text="item.category_name "></v-list-item-title>
                  <v-list-item-title v-else v-text="item.name "></v-list-item-title>
                  <v-list-item-subtitle v-if="item.type==='cms_page' || item.type==='category' || item.type==='information-page'">{{translations.search.type1}}</v-list-item-subtitle>
                  <v-list-item-subtitle v-else-if="item.type==='event'">{{translations.home.labels.events}}</v-list-item-subtitle>
                  <v-list-item-subtitle v-else-if="item.type==='organisation'">{{translations.home.labels.providers}}</v-list-item-subtitle>
                  <v-list-item-subtitle v-else-if="item.type==='opportunity'">{{translations.home.labels.apprenticeships}}</v-list-item-subtitle>
                  <v-list-item-subtitle v-else v-text="item.type.replace(/[_-]/g, ' ')"></v-list-item-subtitle>
                </v-list-item-content>
              </RouterLink>
            </v-list-item>
          </v-list>
        </template>
      </v-data-iterator>
    </div>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";

export default {
  data: () => ({
    search: "",
    page: 1,
    itemsPerPage: 10,
    sortBy: 'name',
    localPages: [
      {
        name: "Contact",
        type: "information-page",
        id: "contact"
      }
    ]
  }),
  methods: {
    openPage(item) {
      if (item.type === "organisation") {
        return { name: 'organisation', params: { id: item.id }}
      } else if (item.type === "cms_page") {
        return { name: 'cms_page', params: { id: item.id }}
      } else if (item.type === "opportunity") {
        return { name: 'Opportunity', params: { id: item.id }}
      } else if (item.type === "event") {
        return { name: 'event', params: { id: item.id }}
      } else if (item.type === "category") {
        return { name: 'category', params: { id: item.id }}
      } else if (item.type === "information-page") {
        return "/" + item.id
      }
    }
  },
  computed: {
    contact() {
      return hubbdata.getters.contact
    },
    translations() {
      return hubbdata.getters.translations;
    },
    pages () {
      return this.searchApp.slice(0, 20)
    },
    pagesNumber () {
      return this.searchApp.length / 20
    },
    searchApp() {
      var results = [];
      results.push(hubbdata.state.cms_pages.filter((cms_pages) => {
        return cms_pages.page_title.toLowerCase().includes(this.search.toLowerCase());
      }));
      results.push(hubbdata.state.organisations.filter((organisations) => {
        return organisations.name.toLowerCase().includes(this.search.toLowerCase());
      }));
      results.push(this.localPages.filter((localpage) => {
        return localpage.name.toLowerCase().includes(this.search.toLowerCase());
      }));
      results.push(hubbdata.state.events.filter((events) => {
        return events.name.toLowerCase().includes(this.search.toLowerCase());
      }));
      results.push(hubbdata.state.opportunities.filter((opportunities) => {
        return opportunities.name.toLowerCase().includes(this.search.toLowerCase());
      }));

      sessionStorage.setItem('search', this.search);

      return results.flat()
    }
  },
  mounted() {
    this.localPages[0].name = hubbdata.getters.translations.home.labels.contact
    // this.localPages[1].name = hubbdata.getters.translations.tabs.surveys
    if (sessionStorage.getItem('search') !== null) {
      this.search = sessionStorage.getItem('search')
    }
    ga('set', 'title', 'App Search'); // eslint-disable-line
    ga('send', 'pageview', location.href); // eslint-disable-line
  },
}
</script>

<style lang="scss" >
.search__container {

  .results-text {
    padding: 10px;
    text-align: center;
    border-bottom: 1px solid #42113C;
  }

  .v-list-item {
    border-bottom: 1px solid #42113C ;
  }

  .v-list {
    padding-bottom: 55px;
  }

  h1 {
    text-align: center;
    padding-top: 20px;
  }

  .v-btn--icon {
    background-color: $primary !important;
    color: white !important;

    .v-btn__content {
      i {
        color: white !important;
      }
    }
  }

  .v-data-footer__pagination {
    margin: 0 19px 0 19px;
  }

  .v-data-footer {
    position: fixed;
    bottom: 0px;
    background-color: $grey !important;
    padding-bottom: 25px;
    width: 100%;

    @media screen and (min-width: 960px) {
      display: flex;
      justify-content: center;
      width: calc(100vw - 256px);
    }
  }

  .v-data-footer__select {
    margin-right: 0px;
  }

  .v-input--hide-details {
    margin: 9px 0px 9px 5px !important;
  }
}

.app-search {

  &__list-item-link {
    display: flex;
    width: 100%;
    text-decoration: none;
  }
}

.search-input {

  .v-input__icon--clear {

    button {
      border-radius: 50%;
      transition: none;

      &:focus {
        outline: 2px solid $black;
        outline-offset: 2px;
      }
    }
  }

  .custom-clear-icon {
    border-radius: 50%;
    transition: none;

    &:focus {
      outline: 2px solid $black;
      outline-offset: 2px;
    }
  }
}
</style>